const UE = () => {
  var is_qq_built_in_browser = false; //qq内置浏览器
  var is_other_browser = false; //其他浏览器
  var isAndroidTenxun = false;
  var isAndroid = false;
  var isiPad = false;
  var isIOS = false;
  var isIOS9 = false;
  const NU = navigator.userAgent;
  const ua = NU.toLowerCase();
  if (ua.indexOf('android') > -1 || ua.indexOf('linux') > -1) {
    isAndroid = true;
    if (ua.indexOf('micromessenger') > -1 || (ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') > -1)) {
      isAndroidTenxun = true;
    }
  }
  if (ua.indexOf('iphone') > -1 || ua.indexOf('ios') > -1 || ua.indexOf('ipad') > -1) {
    isIOS = true;
    if (ua.indexOf('ipad') > -1) {
      isiPad = true;
    }
  }
  if (ua.indexOf('qq') > -1 && ua.indexOf('mqqbrowser') < 0) {
    is_qq_built_in_browser = true;
  }
  if (
    ua.indexOf('baiduboxapp') > -1 || //百度
    ua.indexOf('sogoumobilebrowser') > -1 || //搜狗
    ua.indexOf('qhbrowsr') > -1 || //360
    ua.indexOf('mxios') > -1 || // 遨游
    ua.indexOf('fxios') > -1 || //火狐
    ua.indexOf('crios') > -1 || //google
    ua.indexOf('mqqbrowser') > -1 || //qq浏览器
    ua.indexOf('ucbrowser') > -1 || //uc
    ua.indexOf('micromessenger') > -1 || //微信内置
    (ua.indexOf('safari') > -1 && ua.indexOf('mobile') > -1) //safari
  ) {
    is_other_browser = true;
  }
  function isIOS9FN () {
    //获取固件版本
    function getOsv () {
      var reg = /OS ((\d+_?){2,3})\s/;
      if (NU.match(/iPad/i) || navigator.platform.match(/iPad/i) || NU.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
        var osv = reg.exec(NU);
        if (osv.length > 0) {
          return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
        }
      }
      return '';
    }
    var osv = getOsv();
    var osvArr = osv.split('.');
    //初始化显示ios9引导
    if (osvArr && osvArr.length > 0) {
      if (parseInt(osvArr[0]) >= 9) {
        isIOS9 = true;
      }
    }
    isIOS9 = false;
  }
  isIOS9FN();

  function vs () {
    if (isAndroid) {
      const index = NU.indexOf("Android");
      const str = NU.slice(index + 8, NU.length - 1);
      const index2 = str.indexOf(";");
      const str1 = str.slice(0, index2);
      return str1;
    }
    if (isIOS) {
      const index = NU.indexOf("OS");
      const str = NU.slice(index + 3, NU.length - 1);
      const index2 = str.indexOf(" ");
      const str1 = str.slice(0, index2);
      const str2 = str1.replace('_', '.');
      const str3 = str2.replace('_', '.');
      return str3;
    }
  }

  function model () {
    if (isAndroid) {
      return 'android';
    }
    if (isIOS) {
      if (isiPad) {
        return 'iPad';
      } else {
        return 'iPhone';
      }
    }
  }

  var vw = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  var vh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  var infoPhone = {};
  if (isIOS) {
    infoPhone = {
      "account": "",
      "pwd": "",
      "uid": "0",
      "engine_id": "iPhone_BookStore",
      "version": "7.35",
      "platform": "touch",
      "device_info": {
        "systemVersion": vs(),
        "model": "iPhone", "screen": `${vw}x${vh}`
      },
      "extra_info": {
        "app_version": "4.6.1",
        "isJail": 0,
        "bundle_identifier": "com.docin.DocInBookshelfHDHuZhao",
      },
    }
  }
  if (isAndroid) {
    infoPhone = {
      "account": "",
      "pwd": "",
      "uid": "",
      "engine_id": "Android_BookStore",
      "version": "7.35",
      "platform": "touch",
      "device_info": { "model": "android", "screen": `${vw}x${vh}` },
      "extra_info": { "app_version": 4507 },
    }
  }

  function bs (t) {
    if (t === '热门') {
      return "1";
    }
    if (t === '相关') {
      return "2";
    }
    if (t === '最新') {
      return "3";
    }
    if (t === '完本') {
      return "6";
    }
    if (t === '字数') {
      return "7";
    }
    return "0";
  }

  return {
    is_qq_built_in_browser,
    is_other_browser,
    isAndroidTenxun,
    isAndroid,
    isIOS,
    isIOS9,
    infoPhone,
    bs
  };
};

export default UE;
